import { useTranslation } from "react-i18next";
import React from "react";
import { Avatar, Tooltip } from "antd";

interface AvatarPreviewProps {
  count?: number;
  items: string[];
  names?: string[];
}

const defaultColors = ["#fde3cf", "#1677ff", "#f56a00", "#87d068"];

function AvatarPreview({
  count = 3,
  items = [],
  names = [],
}: AvatarPreviewProps) {
  const { t } = useTranslation();
  function getRandomColor(): string {
    const randomIndex = Math.floor(Math.random() * defaultColors.length);
    return defaultColors[randomIndex];
  }

  const renderAvatars = () => {
    if (!items?.length) return "";

    return items.map((item: string, index) => (
      <Tooltip title={names[index] || t("Không có tên", "Không có tên")} key={index}>
        <Avatar
          className="pointer"
          key={index}
          src={item}
          style={{ backgroundColor: getRandomColor() }}
        >
          {names[index]?.charAt(0) || "User"}
        </Avatar>
      </Tooltip>
    ));
  };

  return (
    <div>
      <Avatar.Group
        size="default"
        max={{
          count: count,
          style: { color: "#f56a00", backgroundColor: "#fde3cf" },
        }}
      >
        {renderAvatars()}
      </Avatar.Group>
    </div>
  );
}

export default AvatarPreview;
